import React from 'react';
import { motion } from 'framer-motion';

const CTA: React.FC = () => {
  const handleButtonClick = () => {
    window.open('https://app.prediedge.com/?utm_source=site&utm_medium=cta&utm_campaign=landing', '_blank');
  };

  return (
    <section className="cta">
      <div className="section-container">
        <motion.div 
          className="cta-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ 
            duration: 0.6,
            ease: [0.25, 0.25, 0.25, 0.75]
          }}
          viewport={{ 
            once: true, 
            margin: "-50px",
            amount: 0.3 
          }}
        >
          <h2>Ready to Get the Flow?</h2>
          <p>Launch the app and start tracking markets now.</p>
          <motion.button 
            className="btn btn-primary btn-large"
            whileHover={{ 
              scale: 1.02,
              transition: { duration: 0.2, ease: "easeOut" }
            }}
            whileTap={{ 
              scale: 0.98,
              transition: { duration: 0.1 }
            }}
            onClick={handleButtonClick}
          >
            Launch App
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA; 